/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.growth.post.purchases.rpc.server.GrowthPostPurchasesChirpService
 */

export const validatePortalForGrowthProPlusExposureRpc = {
  serviceName: 'com.hubspot.growth.post.purchases.rpc.server.GrowthPostPurchasesChirpService',
  rpcName: 'validatePortalForGrowthProPlusExposure',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAC2E1bZDbAGHHAxR8r23tOt'
};
export const checkHubsForPortalRpc = {
  serviceName: 'com.hubspot.growth.post.purchases.rpc.server.GrowthPostPurchasesChirpService',
  rpcName: 'checkHubsForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADfIsqjaG4bbHAxR8r23tOt'
};
export const getActiveHubsRpc = {
  serviceName: 'com.hubspot.growth.post.purchases.rpc.server.GrowthPostPurchasesChirpService',
  rpcName: 'getActiveHubs',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACOyeOsZIaOdnAxR8r23tOt'
};